import React from 'react';
import Header2 from '../components/Header2';
import CareerHeadingSection from '../components/CareerHeadingSection';
import CareerFormSection from '../components/CareerFormSection';
import Footer from '../components/Footer';
import backgroundImage from '../assets/images/img11.jpg';
import WhatsAppButton from '../components/WhatsAppButton';

// ! الخطوة 1: استيراد مكون الأنيميشن وملف الـ CSS الخاص به
import AnimateOnScroll from '../components/AnimateOnScroll';
import '../assets/css/animations.css';

function CareersPage() {
  const heroStyle = {
    minHeight: '30vh',
    width: '100%',
    backgroundImage: `url(${backgroundImage})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    textAlign: 'center',
    padding: '0 1rem',
    position: 'relative',
    overflow: 'hidden',
  };

  return (
    <>
      <Header2 />

      {/* ! الخطوة 2: تغليف الأقسام المراد تحريكها */}
      <AnimateOnScroll>
        <section style={heroStyle}>
          {/* هذا القسم سيظهر بالتدريج عند تحميل الصفحة */}
        </section>
      </AnimateOnScroll>

      <AnimateOnScroll>
        <CareerHeadingSection />
      </AnimateOnScroll>

      <AnimateOnScroll>
        <CareerFormSection />
      </AnimateOnScroll>
      
      <WhatsAppButton/>
      <Footer />
    </>
  );
}

export default CareersPage;